<template>
  <div :class="classes" class="w-48"></div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { Width, Background } from "./types";

export interface SkeletonProps {
  width?: Width;
  bg?: Background;
}

const widthOptions = {
  xs: "tw-max-w-[270px]",
  sm: "tw-max-w-[300px]",
  md: "tw-max-w-[330px]",
  lg: "tw-max-w-[360px]",
};

const bgOptions = {
  light: "tw-bg-primary-grey-50",
  default: "tw-bg-primary-grey-100",
};

const props = withDefaults(defineProps<SkeletonProps>(), {
  width: "xs",
  bg: "default",
});

const classes = computed(() => {
  return [
    widthOptions[props.width],
    "tw-mb-4 tw-h-2.5 tw-rounded-full",
    bgOptions[props.bg],
  ];
});
</script>
